const DEFAULT_MOVIES = [
    {
        id: 185,
        title: 'A Clockwork Orange',
        release_date: '1971-12-18',
        popularity: 19.827,
        genre_ids: [878, 18],
    },
    {
        id: 389,
        title: '12 Angry Men',
        release_date: '1957-04-10',
        popularity: 20.79,
        genre_ids: [18],
    },
    {
        id: 429,
        title: 'The Good, the Bad and the Ugly',
        release_date: '1966-12-23',
        popularity: 24.095,
        genre_ids: [37],
    },
    {
        id: 238,
        title: 'The Godfather',
        release_date: '1972-03-14',
        popularity: 45.891,
        genre_ids: [80, 18],
    },
    {
        id: 1891,
        title: 'The Empire Strikes Back',
        release_date: '1980-05-20',
        popularity: 28.836,
        genre_ids: [28, 12, 878],
    },
    {
        id: 510,
        title: "One Flew Over the Cuckoo's Nest",
        release_date: '1975-11-18',
        popularity: 20.275,
        genre_ids: [18],
    },
    {
        id: 348,
        title: 'Alien',
        release_date: '1979-05-25',
        popularity: 33.181,
        genre_ids: [27, 878],
    },
    {
        id: 240,
        title: 'The Godfather: Part II',
        release_date: '1974-12-20',
        popularity: 27.565,
        genre_ids: [80, 18],
    },
    {
        id: 103,
        title: 'Taxi Driver',
        release_date: '1976-02-07',
        popularity: 22.34,
        genre_ids: [80, 18],
    },
    {
        id: 11,
        title: 'Star Wars',
        release_date: '1977-05-25',
        popularity: 63.564,
        genre_ids: [28, 12, 878],
    },
    {
        id: 694,
        title: 'The Shining',
        release_date: '1980-05-23',
        popularity: 24.145,
        genre_ids: [27, 53],
    },
    {
        id: 1892,
        title: 'Return of the Jedi',
        release_date: '1983-05-25',
        popularity: 20.737,
        genre_ids: [28, 12, 878],
    },
    {
        id: 85,
        title: 'Raiders of the Lost Ark',
        release_date: '1981-06-12',
        popularity: 31.549,
        genre_ids: [12, 28],
    },
    {
        id: 78,
        title: 'Blade Runner',
        release_date: '1982-06-25',
        popularity: 32.799,
        genre_ids: [18, 878, 53],
    },
    {
        id: 111,
        title: 'Scarface',
        release_date: '1983-12-08',
        popularity: 21.336,
        genre_ids: [28, 80, 18, 53],
    },
    {
        id: 105,
        title: 'Back to the Future',
        release_date: '1985-07-03',
        popularity: 39.001,
        genre_ids: [12, 35, 878, 10751],
    },
    {
        id: 218,
        title: 'The Terminator',
        release_date: '1984-10-26',
        popularity: 33.613,
        genre_ids: [28, 53, 878],
    },
    {
        id: 600,
        title: 'Full Metal Jacket',
        release_date: '1987-06-26',
        popularity: 16.992,
        genre_ids: [18, 10752],
    },
    {
        id: 679,
        title: 'Aliens',
        release_date: '1986-07-18',
        popularity: 21.702,
        genre_ids: [28, 878, 53],
    },
    {
        id: 562,
        title: 'Die Hard',
        release_date: '1988-07-15',
        popularity: 24.335,
        genre_ids: [28, 53],
    },
    {
        id: 89,
        title: 'Indiana Jones and the Last Crusade',
        release_date: '1989-05-24',
        popularity: 24.817,
        genre_ids: [28, 12],
    },
    {
        id: 769,
        title: 'GoodFellas',
        release_date: '1990-09-12',
        popularity: 25.887,
        genre_ids: [80, 18],
    },
    {
        id: 280,
        title: 'Terminator 2: Judgment Day',
        release_date: '1991-07-03',
        popularity: 29.74,
        genre_ids: [28, 878, 53],
    },
    {
        id: 500,
        title: 'Reservoir Dogs',
        release_date: '1992-09-02',
        popularity: 20.964,
        genre_ids: [80, 53],
    },
    {
        id: 274,
        title: 'The Silence of the Lambs',
        release_date: '1991-02-01',
        popularity: 5.511,
        genre_ids: [80, 18, 27, 53],
    },
    {
        id: 329,
        title: 'Jurassic Park',
        release_date: '1993-06-11',
        popularity: 18.76,
        genre_ids: [12, 878],
    },
    {
        id: 424,
        title: "Schindler's List",
        release_date: '1993-11-30',
        popularity: 33.281,
        genre_ids: [18, 36, 10752],
    },
    {
        id: 13,
        title: 'Forrest Gump',
        release_date: '1994-07-06',
        popularity: 36.151,
        genre_ids: [35, 18, 10749],
    },
    {
        id: 8587,
        title: 'The Lion King',
        release_date: '1994-05-07',
        popularity: 35.26,
        genre_ids: [16, 18, 10751],
    },
    {
        id: 101,
        title: 'Léon: The Professional',
        release_date: '1994-09-14',
        popularity: 39.276,
        genre_ids: [28, 80, 18],
    },
    {
        id: 680,
        title: 'Pulp Fiction',
        release_date: '1994-09-10',
        popularity: 44.17,
        genre_ids: [80, 53],
    },
    {
        id: 629,
        title: 'The Usual Suspects',
        release_date: '1995-07-19',
        popularity: 19.876,
        genre_ids: [18, 80, 53],
    },
    {
        id: 278,
        title: 'The Shawshank Redemption',
        release_date: '1994-09-23',
        popularity: 55.303,
        genre_ids: [80, 18],
    },
    {
        id: 197,
        title: 'Braveheart',
        release_date: '1995-05-24',
        popularity: 22.714,
        genre_ids: [28, 18, 36, 10752],
    },
    {
        id: 862,
        title: 'Toy Story',
        release_date: '1995-10-30',
        popularity: 32.97,
        genre_ids: [16, 35, 10751],
    },
    {
        id: 807,
        title: 'Se7en',
        release_date: '1995-09-22',
        popularity: 36.515,
        genre_ids: [80, 9648, 53],
    },
    {
        id: 115,
        title: 'The Big Lebowski',
        release_date: '1998-03-06',
        popularity: 28.301,
        genre_ids: [35, 80],
    },
    {
        id: 73,
        title: 'American History X',
        release_date: '1998-10-30',
        popularity: 19.231,
        genre_ids: [18],
    },
    {
        id: 489,
        title: 'Good Will Hunting',
        release_date: '1997-12-05',
        popularity: 16.311,
        genre_ids: [18],
    },
    {
        id: 597,
        title: 'Titanic',
        release_date: '1997-11-18',
        popularity: 32.998,
        genre_ids: [18, 10749],
    },
    {
        id: 37165,
        title: 'The Truman Show',
        release_date: '1998-06-04',
        popularity: 22.161,
        genre_ids: [35, 18],
    },
    {
        id: 497,
        title: 'The Green Mile',
        release_date: '1999-12-10',
        popularity: 25.903,
        genre_ids: [80, 18, 14],
    },
    {
        id: 603,
        title: 'The Matrix',
        release_date: '1999-03-30',
        popularity: 55.166,
        genre_ids: [28, 878],
    },
    {
        id: 120,
        title: 'The Lord of the Rings: The Fellowship of the Ring',
        release_date: '2001-12-18',
        popularity: 43.376,
        genre_ids: [28, 12, 14],
    },
    {
        id: 857,
        title: 'Saving Private Ryan',
        release_date: '1998-07-24',
        popularity: 29.129,
        genre_ids: [18, 36, 10752],
    },
    {
        id: 1895,
        title: 'Star Wars: Episode III - Revenge of the Sith',
        release_date: '2005-05-17',
        popularity: 25.236,
        genre_ids: [28, 12, 878],
    },
    {
        id: 557,
        title: 'Spider-Man',
        release_date: '2002-05-01',
        popularity: 36.743,
        genre_ids: [28, 14],
    },
    {
        id: 550,
        title: 'Fight Club',
        release_date: '1999-10-15',
        popularity: 33.584,
        genre_ids: [18],
    },
    {
        id: 122,
        title: 'The Lord of the Rings: The Return of the King',
        release_date: '2003-12-01',
        popularity: 36.596,
        genre_ids: [28, 12, 14],
    },
    {
        id: 121,
        title: 'The Lord of the Rings: The Two Towers',
        release_date: '2002-12-18',
        popularity: 28.991,
        genre_ids: [28, 12, 14],
    },
    {
        id: 745,
        title: 'The Sixth Sense',
        release_date: '1999-08-06',
        popularity: 21.014,
        genre_ids: [18, 9648, 53],
    },
    {
        id: 98,
        title: 'Gladiator',
        release_date: '2000-05-01',
        popularity: 34.515,
        genre_ids: [28, 12, 18],
    },
    {
        id: 14,
        title: 'American Beauty',
        release_date: '1999-09-15',
        popularity: 20.81,
        genre_ids: [18],
    },
    {
        id: 585,
        title: 'Monsters, Inc.',
        release_date: '2001-11-01',
        popularity: 37.408,
        genre_ids: [16, 35, 10751],
    },
    {
        id: 641,
        title: 'Requiem for a Dream',
        release_date: '2000-10-06',
        popularity: 7.246,
        genre_ids: [80, 18],
    },
    {
        id: 194,
        title: 'Amélie',
        release_date: '2001-04-25',
        popularity: 23.853,
        genre_ids: [35, 10749],
    },
    {
        id: 107,
        title: 'Snatch',
        release_date: '2000-09-01',
        popularity: 18.865,
        genre_ids: [80, 53],
    },
    {
        id: 77,
        title: 'Memento',
        release_date: '2000-10-11',
        popularity: 26.712,
        genre_ids: [9648, 53],
    },
    {
        id: 640,
        title: 'Catch Me If You Can',
        release_date: '2002-12-25',
        popularity: 50.492,
        genre_ids: [80, 18],
    },
    {
        id: 423,
        title: 'The Pianist',
        release_date: '2002-09-17',
        popularity: 18.294,
        genre_ids: [18, 10752],
    },
    {
        id: 141,
        title: 'Donnie Darko',
        release_date: '2001-01-18',
        popularity: 22.778,
        genre_ids: [18, 14, 9648],
    },
    {
        id: 453,
        title: 'A Beautiful Mind',
        release_date: '2001-12-11',
        popularity: 19.179,
        genre_ids: [18, 10749],
    },
    {
        id: 12,
        title: 'Finding Nemo',
        release_date: '2003-05-30',
        popularity: 35.059,
        genre_ids: [16, 10751],
    },
    {
        id: 24,
        title: 'Kill Bill: Vol. 1',
        release_date: '2003-10-10',
        popularity: 24.098,
        genre_ids: [28, 80],
    },
    {
        id: 598,
        title: 'City of God',
        release_date: '2002-02-05',
        popularity: 17.544,
        genre_ids: [80, 18],
    },
    {
        id: 9806,
        title: 'The Incredibles',
        release_date: '2004-11-05',
        popularity: 32.04,
        genre_ids: [28, 12, 16, 10751],
    },
    {
        id: 38,
        title: 'Eternal Sunshine of the Spotless Mind',
        release_date: '2004-03-19',
        popularity: 23.755,
        genre_ids: [18, 878, 10749],
    },
    {
        id: 22,
        title: 'Pirates of the Caribbean: The Curse of the Black Pearl',
        release_date: '2003-07-09',
        popularity: 47.367,
        genre_ids: [28, 12, 14],
    },
    {
        id: 16869,
        title: 'Inglourious Basterds',
        release_date: '2009-08-18',
        popularity: 25.966,
        genre_ids: [18, 28, 53, 10752],
    },
    {
        id: 187,
        title: 'Sin City',
        release_date: '2005-04-01',
        popularity: 16.775,
        genre_ids: [28, 80, 53],
    },
    {
        id: 1726,
        title: 'Iron Man',
        release_date: '2008-04-30',
        popularity: 48.532,
        genre_ids: [28, 12, 878],
    },
    {
        id: 272,
        title: 'Batman Begins',
        release_date: '2005-06-10',
        popularity: 34.119,
        genre_ids: [28, 80, 18],
    },
    {
        id: 393,
        title: 'Kill Bill: Vol. 2',
        release_date: '2004-04-16',
        popularity: 22.333,
        genre_ids: [28, 80, 53],
    },
    {
        id: 58,
        title: "Pirates of the Caribbean: Dead Man's Chest",
        release_date: '2006-06-20',
        popularity: 30.924,
        genre_ids: [28, 12, 14],
    },
    {
        id: 752,
        title: 'V for Vendetta',
        release_date: '2006-02-23',
        popularity: 22.873,
        genre_ids: [28, 14, 53],
    },
    {
        id: 1271,
        title: '300',
        release_date: '2007-03-07',
        popularity: 21.458,
        genre_ids: [28, 12, 10752],
    },
    {
        id: 1422,
        title: 'The Departed',
        release_date: '2006-10-05',
        popularity: 26.448,
        genre_ids: [80, 18, 53],
    },
    {
        id: 10193,
        title: 'Toy Story 3',
        release_date: '2010-06-16',
        popularity: 26.767,
        genre_ids: [16, 35, 10751],
    },
    {
        id: 1124,
        title: 'The Prestige',
        release_date: '2006-10-19',
        popularity: 29.628,
        genre_ids: [18, 9648, 53],
    },
    {
        id: 155,
        title: 'The Dark Knight',
        release_date: '2008-07-16',
        popularity: 42.604,
        genre_ids: [28, 80, 18, 53],
    },
    {
        id: 6977,
        title: 'No Country for Old Men',
        release_date: '2007-11-08',
        popularity: 33.427,
        genre_ids: [80, 18, 53],
    },
    {
        id: 6479,
        title: 'I Am Legend',
        release_date: '2007-12-14',
        popularity: 23.918,
        genre_ids: [28, 18, 27, 878, 53],
    },
    {
        id: 157336,
        title: 'Interstellar',
        release_date: '2014-11-05',
        popularity: 62.36,
        genre_ids: [12, 18, 878],
    },
    {
        id: 19995,
        title: 'Avatar',
        release_date: '2009-12-10',
        popularity: 34.73,
        genre_ids: [28, 12, 14, 878],
    },
    {
        id: 10191,
        title: 'How to Train Your Dragon',
        release_date: '2010-03-10',
        popularity: 25.965,
        genre_ids: [12, 16, 14, 10751],
    },
    {
        id: 24428,
        title: 'The Avengers',
        release_date: '2012-04-25',
        popularity: 71.821,
        genre_ids: [28, 12, 878],
    },
    {
        id: 44214,
        title: 'Black Swan',
        release_date: '2010-12-03',
        popularity: 22.018,
        genre_ids: [18, 27, 53],
    },
    {
        id: 10681,
        title: 'WALL·E',
        release_date: '2008-06-22',
        popularity: 30.208,
        genre_ids: [16, 878, 10751],
    },
    {
        id: 49051,
        title: 'The Hobbit: An Unexpected Journey',
        release_date: '2012-11-26',
        popularity: 27.912,
        genre_ids: [28, 12, 14],
    },
    {
        id: 82693,
        title: 'Silver Linings Playbook',
        release_date: '2012-09-08',
        popularity: 18.512,
        genre_ids: [35, 18, 10749],
    },
    {
        id: 106646,
        title: 'The Wolf of Wall Street',
        release_date: '2013-12-25',
        popularity: 35.648,
        genre_ids: [35, 80, 18],
    },
    {
        id: 12405,
        title: 'Slumdog Millionaire',
        release_date: '2008-05-12',
        popularity: 16.62,
        genre_ids: [18, 10749],
    },
    {
        id: 13223,
        title: 'Gran Torino',
        release_date: '2008-12-09',
        popularity: 17.232,
        genre_ids: [18],
    },
    {
        id: 17654,
        title: 'District 9',
        release_date: '2009-08-05',
        popularity: 20.832,
        genre_ids: [878],
    },
    {
        id: 12445,
        title: 'Harry Potter and the Deathly Hallows: Part 2',
        release_date: '2011-07-07',
        popularity: 36.769,
        genre_ids: [12, 14],
    },
    {
        id: 14160,
        title: 'Up',
        release_date: '2009-05-28',
        popularity: 28.284,
        genre_ids: [12, 16, 35, 10751],
    },
    {
        id: 18785,
        title: 'The Hangover',
        release_date: '2009-06-02',
        popularity: 18.947,
        genre_ids: [35],
    },
    {
        id: 11324,
        title: 'Shutter Island',
        release_date: '2010-02-14',
        popularity: 32.282,
        genre_ids: [18, 53, 9648],
    },
    {
        id: 49026,
        title: 'The Dark Knight Rises',
        release_date: '2012-07-16',
        popularity: 29.91,
        genre_ids: [28, 80, 18, 53],
    },
    {
        id: 49538,
        title: 'X-Men: First Class',
        release_date: '2011-06-01',
        popularity: 1.099,
        genre_ids: [28, 12, 878],
    },
    {
        id: 68721,
        title: 'Iron Man 3',
        release_date: '2013-04-18',
        popularity: 29.446,
        genre_ids: [28, 12, 878],
    },
    {
        id: 100402,
        title: 'Captain America: The Winter Soldier',
        release_date: '2014-03-20',
        popularity: 19.4,
        genre_ids: [28, 12, 878],
    },
    {
        id: 27205,
        title: 'Inception',
        release_date: '2010-07-15',
        popularity: 51.654,
        genre_ids: [28, 12, 878],
    },
    {
        id: 281957,
        title: 'The Revenant',
        release_date: '2015-12-25',
        popularity: 27.429,
        genre_ids: [37, 18, 12],
    },
    {
        id: 77338,
        title: 'The Intouchables',
        release_date: '2011-11-02',
        popularity: 24.174,
        genre_ids: [35, 18],
    },
    {
        id: 70160,
        title: 'The Hunger Games',
        release_date: '2012-03-12',
        popularity: 16.884,
        genre_ids: [12, 14, 878],
    },
    {
        id: 76341,
        title: 'Mad Max: Fury Road',
        release_date: '2015-05-13',
        popularity: 31.019,
        genre_ids: [28, 12, 878],
    },
    {
        id: 293660,
        title: 'Deadpool',
        release_date: '2016-02-09',
        popularity: 39.423,
        genre_ids: [28, 12, 35],
    },
    {
        id: 49047,
        title: 'Gravity',
        release_date: '2013-10-03',
        popularity: 19.148,
        genre_ids: [878, 53, 18],
    },
    {
        id: 118340,
        title: 'Guardians of the Galaxy',
        release_date: '2014-07-30',
        popularity: 27.027,
        genre_ids: [28, 12, 878],
    },
    {
        id: 127585,
        title: 'X-Men: Days of Future Past',
        release_date: '2014-05-15',
        popularity: 29.261,
        genre_ids: [28, 12, 14, 878],
    },
    {
        id: 68718,
        title: 'Django Unchained',
        release_date: '2012-12-25',
        popularity: 29.613,
        genre_ids: [18, 37],
    },
    {
        id: 210577,
        title: 'Gone Girl',
        release_date: '2014-10-01',
        popularity: 64.783,
        genre_ids: [18, 9648, 53],
    },
    {
        id: 205596,
        title: 'The Imitation Game',
        release_date: '2014-11-14',
        popularity: 33.853,
        genre_ids: [18, 36, 53, 10752],
    },
    {
        id: 120467,
        title: 'The Grand Budapest Hotel',
        release_date: '2014-02-26',
        popularity: 20.742,
        genre_ids: [35, 18],
    },
    {
        id: 99861,
        title: 'Avengers: Age of Ultron',
        release_date: '2015-04-22',
        popularity: 46.029,
        genre_ids: [28, 12, 878],
    },
    {
        id: 271110,
        title: 'Captain America: Civil War',
        release_date: '2016-04-27',
        popularity: 46.539,
        genre_ids: [28, 12, 878],
    },
    {
        id: 244786,
        title: 'Whiplash',
        release_date: '2014-10-10',
        popularity: 37.443,
        genre_ids: [18, 10402],
    },
    {
        id: 140607,
        title: 'Star Wars: The Force Awakens',
        release_date: '2015-12-15',
        popularity: 41.713,
        genre_ids: [28, 12, 14, 878],
    },
    {
        id: 475557,
        title: 'Joker',
        release_date: '2019-10-02',
        popularity: 106.417,
        genre_ids: [80, 18, 53],
    },
    {
        id: 286217,
        title: 'The Martian',
        release_date: '2015-09-30',
        popularity: 32.479,
        genre_ids: [12, 18, 878],
    },
    {
        id: 299536,
        title: 'Avengers: Infinity War',
        release_date: '2018-04-25',
        popularity: 76.243,
        genre_ids: [28, 12, 878],
    },
    {
        id: 299534,
        title: 'Avengers: Endgame',
        release_date: '2019-04-24',
        popularity: 51.908,
        genre_ids: [12, 878, 28],
    },
]

export default DEFAULT_MOVIES
